import RatioRankingStatCalculator from './RatioRankingStatCalculator.js';
import BattingRankingStats from '../../enums/BattingRankingStats.js';

// TODO - move to some kind of factory
const bettingRatioStatsCalculator = new RatioRankingStatCalculator();
bettingRatioStatsCalculator.registerParameter(
    BattingRankingStats.PitchesPerPa, BattingRankingStats.NumberOfPitches, BattingRankingStats.PlateAppearances
);
bettingRatioStatsCalculator.registerParameter(
    BattingRankingStats.OnBasePercentage, BattingRankingStats.TimesOnBase, BattingRankingStats.PlateAppearances
);
bettingRatioStatsCalculator.registerParameter(
    BattingRankingStats.WalkRate, BattingRankingStats.Walks, BattingRankingStats.PlateAppearances
);
bettingRatioStatsCalculator.registerParameter(
    BattingRankingStats.StrikeoutRate, BattingRankingStats.Strikeouts, BattingRankingStats.PlateAppearances
);
bettingRatioStatsCalculator.registerParameter(
    BattingRankingStats.KZoneRate, BattingRankingStats.KZonePitches, BattingRankingStats.NumberOfPitches
);
bettingRatioStatsCalculator.registerParameter(
    BattingRankingStats.SwingRate, BattingRankingStats.Swings, BattingRankingStats.NumberOfPitches
);
bettingRatioStatsCalculator.registerParameter(
    BattingRankingStats.SwingingStrikeRate, BattingRankingStats.Whiffs, BattingRankingStats.NumberOfPitches
);
bettingRatioStatsCalculator.registerParameter(
    BattingRankingStats.OSwingRate, BattingRankingStats.OSwings, BattingRankingStats.OZonePitches
);
bettingRatioStatsCalculator.registerParameter(
    BattingRankingStats.OContactRate, BattingRankingStats.OContacts, BattingRankingStats.OSwings
);
bettingRatioStatsCalculator.registerParameter(
    BattingRankingStats.OWhiffRate, BattingRankingStats.OWhiffs, BattingRankingStats.OSwings
);
bettingRatioStatsCalculator.registerParameter(
    BattingRankingStats.ZSwingRate, BattingRankingStats.ZSwings, BattingRankingStats.KZonePitches
);
bettingRatioStatsCalculator.registerParameter(
    BattingRankingStats.ZContactRate, BattingRankingStats.ZContacts, BattingRankingStats.ZSwings
);
bettingRatioStatsCalculator.registerParameter(
    BattingRankingStats.ZWhiffRate, BattingRankingStats.ZWhiffs, BattingRankingStats.ZSwings
);
bettingRatioStatsCalculator.registerParameter(
    BattingRankingStats.ContactRate, BattingRankingStats.Contacts, BattingRankingStats.Swings
);
bettingRatioStatsCalculator.registerParameter(
    BattingRankingStats.GroundBallRate, BattingRankingStats.GroundBalls, BattingRankingStats.BattedBalls
);
bettingRatioStatsCalculator.registerParameter(
    BattingRankingStats.LineDriveRate, BattingRankingStats.LineDrives, BattingRankingStats.BattedBalls
);
bettingRatioStatsCalculator.registerParameter(
    BattingRankingStats.FlyBallRate, BattingRankingStats.FlyBalls, BattingRankingStats.BattedBalls
);
bettingRatioStatsCalculator.registerParameter(
    BattingRankingStats.PopUpRate, BattingRankingStats.PopUps, BattingRankingStats.BattedBalls
);
bettingRatioStatsCalculator.registerParameter(
    BattingRankingStats.BattingAverage, BattingRankingStats.Hits, BattingRankingStats.AtBats
);
bettingRatioStatsCalculator.registerParameter(
    BattingRankingStats.SluggingPercentage, BattingRankingStats.TotalBases, BattingRankingStats.AtBats
);
bettingRatioStatsCalculator.registerParameter(
    BattingRankingStats.HardHitRate, BattingRankingStats.HardHits, BattingRankingStats.BattedBalls
);
bettingRatioStatsCalculator.registerParameter(
    BattingRankingStats.GroundOutToAirOutRatio, BattingRankingStats.GroundOuts, BattingRankingStats.AirOuts
);
bettingRatioStatsCalculator.registerParameter(
    BattingRankingStats.WhiffRate, BattingRankingStats.Whiffs, BattingRankingStats.Swings
);

export default bettingRatioStatsCalculator;